import React from 'react';
import CompanyOnboardingWizard from '../components/CompanyOnboardingWizard';

const OnboardingPage = () => {
  return (
    // This container sets the gradient background and centers the content
    <div className="min-h-screen flex items-center justify-center p-4 bg-gray-900 bg-gradient-to-br from-indigo-900/50 via-gray-900 to-fuchsia-900/50 text-white">
      <div className="w-full max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold tracking-tight text-white">
            Mortgage Broker Company Onboarding
          </h1>
          <p className="mt-2 text-slate-400">
            A secure, guided process to set up a new brokerage on the VALUTTEN platform.
          </p>
        </div>
        
        <CompanyOnboardingWizard />
      </div>
    </div>
  );
};

export default OnboardingPage;